import { Component } from '@angular/core';
import { FeedbackService } from 'src/app/form-layout/feedback.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ExcelExportService } from '../excel-export.service';
import * as Excel from 'exceljs';
import { DatePipe } from '@angular/common';
import {
  TerminationsPerEoReportClient,
  TerminationsPerEOReportViewModel,
} from 'src/app/api.service';

@Component({
  selector: 'subs-terminated-per-eo-report',
  templateUrl: './terminated-per-eo.component.html',
  providers: [FeedbackService, DatePipe],
})
export class TerminatedPerEoComponent {
  alertSubject$ = this.feedbackService.alerts;
  submitState = this.feedbackService.submitState;

  columns = [
    {
      header: 'Sponsor Name',
      width: 27,
    },
    {
      header: 'Agency Award Number',
      width: 22,
    },
    {
      header: 'Award FAIN',
      width: 22,
    },
    {
      header: 'RMS#',
      width: 22,
    },
    {
      header: 'WashU PI',
      width: 22,
    },
    {
      header: 'Subaward Number',
      width: 22,
    },
    {
      header: 'Subrecipient Name',
      width: 33,
    },
    {
      header: 'Workday Grant Tag',
      width: 22,
    },
    {
      header: 'Workday Supplier Contract #',
      width: 25,
    },
    {
      header: 'WashU DA RA',
      width: 22,
    },
    {
      header: 'Termination Effective Date',
      width: 22,
    },
    {
      header: 'Date Sent to Sub',
      width: 22,
    },
    {
      header: 'Date status change to Terminated per Executive Order',
      width: 43,
    },
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private feedbackService: FeedbackService,
    private reportService: TerminationsPerEoReportClient,
    private excelExportService: ExcelExportService,
    private datePipe: DatePipe,
  ) {}

  searchForm = this.fb.group({
    dateFrom: ['', Validators.required],
    dateThru: ['', Validators.required],
  });

  clear() {
    this.searchForm.controls.dateFrom.setValue('');
    this.searchForm.controls.dateThru.setValue('');
    this.feedbackService.clearAlert();
  }

  search() {
    this.feedbackService.beginLoading();
    if (this.searchForm.invalid) {
      this.feedbackService.alert(
        'The form is invalid. Please correct all errors before submitting.',
      );
    } else {
      this.reportService
        .get(
          new Date(this.searchForm.controls.dateFrom.value),
          new Date(this.searchForm.controls.dateThru.value),
        )
        .pipe(this.feedbackService.provideFeedback())
        .subscribe(async (val) => {
          await this.generateReport(val);
        });
    }
  }

  async generateReport(results: Array<TerminationsPerEOReportViewModel>) {
    if (results.length === 0) {
      this.feedbackService.alert('There are no results for your search');
      return;
    }

    const data = this.generateReportData(results);
    const numOfTerminations = results.length;
    // const totalsObj = this.generateTotals(results);

    await this.excelExportService.generateExcel(
      'Terminations per Executive Order',
      'Terminations per Executive Order',
      data,
      this.columns,
      {},
      this.addTerminationsCount,
      numOfTerminations,
    );
  }

  private generateReportData(results: Array<TerminationsPerEOReportViewModel>) {
    const data = [];

    results.forEach((e) => {
      data.push([
        e.sponsorName,
        e.agencyAwardNumber,
        e.federalAwardId,
        e.proposalId,
        e.wuPrincipalInvestigator,
        e.agreementNumber,
        e.institutionName,
        e.grantWorkTag,
        e.supplierContractId,
        e.washuDARA,
        e.terminationEffectiveDate
          ? new Date(e.terminationEffectiveDate).toLocaleDateString()
          : '',
        e.dateSentToSub ? new Date(e.dateSentToSub).toLocaleDateString() : '',
        e.dateStatusChangedToTEO
          ? new Date(e.dateStatusChangedToTEO).toLocaleDateString()
          : '',
      ]);
    });
    return data;
  }

  private addTerminationsCount(
    worksheet: Excel.Worksheet,
    numOfTerminations: number,
  ) {
    worksheet.addRow([]);
    //#region Summary Header Row
    const totalRow = worksheet.addRow(['Count of Terminations Per EO']);
    totalRow.font = {
      size: 12,
      bold: true,
    };
    totalRow.eachCell((cell) => {
      cell.alignment = { vertical: 'top' };
      cell.border = {
        top: {
          style: 'thin',
        },
        left: {
          style: 'thin',
        },
        bottom: {
          style: 'thin',
        },
        right: {
          style: 'thin',
        },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D3D3D3' },
      };
    });
    //#endregion

    //#region Summary Data Rows
    const secondRow = worksheet.addRow([numOfTerminations]);
  }
}
